import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
`;

const StyledTh = styled.th`
  padding: 0.2em;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
  cursor: pointer;
  position: relative;
  text-align: center;

  &:after {
    content: '▲';
    position: absolute;
    right: 10px;
    opacity: 0.5;
    transform: rotate(180deg);
    transition: transform 0.3s;
  }

  &:hover:after {
    opacity: 1;
  }

  &.sorted-asc:after {
    content: '▲';
    transform: rotate(0);
  }

  &.sorted-desc:after {
    content: '▼';
  }
`;

const StyledTd = styled.td`
  padding: 12px;
  border: 1px solid #ddd;
`;

const StyledTr = styled.tr`
  &:nth-child(even) {
    background-color: #f2f2f2;
  }
`;

const NoDataTd = styled.td`
  text-align: center;
  background-color: #f9f9f9;
  color: #888;
`;

const Table = ({ columns, dataSource }) => {
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [sortedData, setSortedData] = useState([]);

    useEffect(() => {
        setSortedData(dataSource);
    }, [dataSource]);

    const sortData = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }

        const sortedArray = [...sortedData].sort((a, b) => {
            if (a[key] < b[key]) {
                return direction === 'ascending' ? -1 : 1;
            }
            if (a[key] > b[key]) {
                return direction === 'ascending' ? 1 : -1;
            }
            return 0;
        });

        setSortConfig({ key, direction });
        setSortedData(sortedArray);
    };

    return (
        <StyledTable>
            <thead>
                <tr>
                    {columns.map(column => (
                        <StyledTh
                            key={column.key}
                            onClick={() => sortData(column.dataIndex)}
                            className={
                                sortConfig.key === column.dataIndex
                                    ? sortConfig.direction === 'ascending'
                                        ? 'sorted-asc'
                                        : 'sorted-desc'
                                    : ''
                            }
                        >
                            {column.title}
                        </StyledTh>
                    ))}
                </tr>
            </thead>
            <tbody>
                {sortedData.length > 0 ? (
                    sortedData.map(data => (
                        <StyledTr key={data.key}>
                            {columns.map(column => (
                                <StyledTd key={column.key}>{data[column.dataIndex]}</StyledTd>
                            ))}
                        </StyledTr>
                    ))
                ) : (
                    <tr>
                        <NoDataTd colSpan={columns.length}>無資料</NoDataTd>
                    </tr>
                )}
            </tbody>
        </StyledTable>
    );
};

export default Table;
